export default __webpack_public_path__ + "static/media/menu.10df576a.jpg";